import {Button, Group, Loader, Text} from '@mantine/core';
import {useMachine} from '@xstate/react';
import React from 'react';

import {
  FullScreenFlow,
  FullScreenFlowContent,
  FullScreenFlowFooter,
  FullScreenFlowHeader,
} from 'antibodies/nested-data-creation/full-screen/FullScreenFlowLayout';
import ProteinCreationFlowMachine from 'antibodies/nested-data-creation/full-screen/ProteinCreationFlowMachine';
import * as FullScreenActions from 'nav/full-screen/FullScreenActions';

function ProteinCreationFlowPage(): JSX.Element {
  const [state] = useMachine(ProteinCreationFlowMachine, {input: {}});
  const {selectedSchemaName, selectedFormat} = state.context.creationSettings;

  return (
    <FullScreenFlow>
      <FullScreenFlowHeader
        title="Create proteins"
        subtitle={`${selectedSchemaName} · ${selectedFormat.name}`}
        onClose={() => {
          FullScreenActions.hideScreenForRouting();
        }}
      />
      <FullScreenFlowContent>
        {state.matches('initializing') ? <Loader /> : <Text c="dimmed">Table goes here</Text>}
      </FullScreenFlowContent>
      <FullScreenFlowFooter>
        <Group position="right">
          <Button>Next</Button>
        </Group>
      </FullScreenFlowFooter>
    </FullScreenFlow>
  );
}

export default ProteinCreationFlowPage;
